module.exports = __webpack_public_path__ + "static/media/1001765DO.f66b78b6.jpg";